import { APIServiceConfigInterface } from "@swivl-mono/types";

import { AIAPI } from "./APIs/AI.API";
import { AccountAPI } from "./APIs/Account.API";
import { AdminAPI } from "./APIs/Admin.API";
import { AnalyticsAPI } from "./APIs/Analytics.API";
import { AppsAPI } from "./APIs/Apps.API";
import { AuthAPI } from "./APIs/Auth.API";
import { BotConversationsAPI } from "./APIs/BotConversations.API";
import { BotEvalAPI } from "./APIs/BotEval.API";
import { BotPromptsAPI } from "./APIs/BotPrompts.API";
import { BrainsAPI } from "./APIs/Brains.API";
import { BrandsAPI } from "./APIs/Brands.API";
import { BullAPI } from "./APIs/Bull.API";
import { CRMUsersAPI } from "./APIs/CRMUsers.API";
import { CallScriptAPI } from "./APIs/CallScript.API";
import { CallScriptStepAPI } from "./APIs/CallScriptStep.API";
import { CallsAPI } from "./APIs/Calls.API";
import { CampaignAPI } from "./APIs/Campaign.API";
import { ContactCenterRelayAPI } from "./APIs/ContactCenterRelay.API";
import { ContactCenterV3API } from "./APIs/ContactCenterV3.API";
import { ContactCenterV3AccessAPI } from "./APIs/ContactCenterV3Access.API";
import { ConversationsAPI } from "./APIs/Conversations.API";
import { CortexAPI } from "./APIs/Cortex.API";
import { CtasAPI } from "./APIs/Ctas.API";
import { DebugAPI } from "./APIs/Debug.API";
import { DocumentIngestAPI } from "./APIs/DocumentIngest.API";
import { EmbedPickerAPI } from "./APIs/EmbedPicker.API";
import { EmbedsAPI } from "./APIs/Embeds.API";
import { EscalationsAPI } from "./APIs/Escalations.API";
import { EventsAPI } from "./APIs/Events.API";
import { FMSAPI, FMSServiceProviderInterface, FmsWriteGateInterface } from "./APIs/FMS.API";
import { GlobalSearchAPI } from "./APIs/GlobalSearch.API";
import { GoogleAPI } from "./APIs/Google.API";
import { GroupAPI } from "./APIs/Group";
import { JourneysAPI } from "./APIs/Journeys.API";
import { LeadsAPI } from "./APIs/Leads.API";
import { LeasesAPI } from "./APIs/Leases.API";
import { LegacyServerAPI } from "./APIs/LegacyServer.API";
import { LocationVarsAPI } from "./APIs/LocationVars.API";
import { LocationsAPI } from "./APIs/Locations.API";
import { MemberInviteAPI } from "./APIs/MemberInvite.API";
import { MembersAPI } from "./APIs/Members.API";
import { MenuAPI } from "./APIs/Menu.API";
import { MessagesAPI } from "./APIs/Messages.API";
import { MessagingAPI } from "./APIs/Messaging.API";
import { NLPAPI } from "./APIs/NLP.API";
import { NotesAPI } from "./APIs/Notes.API";
import { NotificationPreferencesAPI } from "./APIs/NotificationPreferences.API";
import { NotificationsAPI } from "./APIs/Notifications.API";
import { OmniAPI } from "./APIs/Omni.API";
import { OnboardingAPI } from "./APIs/Onboarding.API";
import { OrgsAPI } from "./APIs/Orgs.API";
import { OutboundAllowlistAPI } from "./APIs/OutboundAllowlist.API";
import { PaymentsAPI } from "./APIs/Payments.API";
import { PhoneVerificationAPI } from "./APIs/PhoneVerification.API";
import { PolicyAssistantAPI } from "./APIs/PolicyAssistant.API";
import { PolicyNotificationsAPI } from "./APIs/PolicyNotifications.API";
import { PolicyWorksheetsAPI } from "./APIs/PolicyWorksheets.API";
import { PromptTestAPI } from "./APIs/PromptTest.API";
import { PushAPI } from "./APIs/Push.API";
import { QuestsAPI } from "./APIs/Quests.API";
import { ReservationsAPI } from "./APIs/Reservations.API";
import { ReviewsAPI } from "./APIs/Reviews.API";
import { RolesAPI } from "./APIs/Roles.API";
import { RoutingGroupAPI } from "./APIs/RoutingGroup.API";
import { S3API } from "./APIs/S3.API";
import { SMSGroupsAPI } from "./APIs/SMSGroups.API";
import { ScheduleAPI } from "./APIs/Schedule.API";
import { ScraperAPI } from "./APIs/Scraper.API";
import { SequenceConfigAPI } from "./APIs/SequenceConfig.API";
import { SequenceTestRunsAPI } from "./APIs/SequenceTestRuns.API";
import { SequencesAPI } from "./APIs/Sequences.API";
import { SessionsAPI } from "./APIs/Sessions.API";
import { SnowyCampaignsAPI } from "./APIs/SnowyCampaigns.API";
import { SpotAPI } from "./APIs/Spot.API";
import { StarterOpeningsAPI } from "./APIs/StarterOpenings.API";
import { TablesAPI } from "./APIs/Tables.API";
import { TenantPageAPI } from "./APIs/TenantPage.API";
import { TenantsAPI } from "./APIs/Tenants.API";
import { TestCallerAPI } from "./APIs/TestCaller.API";
import { TicketingAPI } from "./APIs/Ticketing.API";
import { TicketingAccessAPI } from "./APIs/TicketingAccess.API";
import { TimeAPI } from "./APIs/Time.API";
import { TwilioSetupAPI } from "./APIs/Twilio.API";
import { URLAPI } from "./APIs/URL.API";
import { UnitsAPI } from "./APIs/Units.API";
import { UserStoriesAPI } from "./APIs/UserStories.API";
import { UserVarsAPI } from "./APIs/UserVars.API";
import { UsersAPI } from "./APIs/Users.API";
import { VarsAPI } from "./APIs/Vars.API";
import { VoiceAPI } from "./APIs/Voice.API";
import { WidgetAccountAPI } from "./APIs/WidgetAccount.API";
import { WidgetIdentityAPI } from "./APIs/WidgetIdentity.API";
import { WidgetsAPI } from "./APIs/Widgets.API";
import { APIService } from "./Service/API.Service";

export class API {
  static init(config: {
    Server?: APIServiceConfigInterface;
    LegacyServer?: APIServiceConfigInterface; //temporary until we migrate over, used for bull
    FMS?: APIServiceConfigInterface;
    Sync?: APIServiceConfigInterface;
    Messaging?: APIServiceConfigInterface;
    Channels?: APIServiceConfigInterface;
    Notifications?: APIServiceConfigInterface;
    Bull?: APIServiceConfigInterface;
    Bot?: APIServiceConfigInterface;
    Analytics?: APIServiceConfigInterface;
    FMSServiceProvider?: FMSServiceProviderInterface;
    /** The Outbound Gate's FMS writer (ENG-3373) — required by every app that writes leads or payments through `API.FMS`. */
    FmsWrite?: FmsWriteGateInterface;
  }) {
    APIService.init(config);
  }
  static log() {
    APIService.log();
  }

  static Account = AccountAPI;
  static Admin = AdminAPI;
  static AI = AIAPI;
  static Apps = AppsAPI;
  static Auth = AuthAPI;
  static Analytics = AnalyticsAPI;
  static BotConversations = BotConversationsAPI;
  static CallScript = CallScriptAPI;
  static CallScriptStep = CallScriptStepAPI;
  static BotEval = BotEvalAPI;
  static BotPrompts = BotPromptsAPI;
  static PolicyAssistant = PolicyAssistantAPI;
  static PromptTest = PromptTestAPI;
  static Brains = BrainsAPI;
  static Brands = BrandsAPI;
  static Bull = BullAPI;
  static Calls = CallsAPI;
  // static Cache: CacheAPIInterface = new CacheAPI();
  static Campaign = CampaignAPI;
  static ContactCenterRelay = ContactCenterRelayAPI;
  static ContactCenterV3 = ContactCenterV3API;
  static ContactCenterV3Access = ContactCenterV3AccessAPI;
  static Cortex = CortexAPI;
  static Conversations = ConversationsAPI;
  static CRMUsers = CRMUsersAPI;
  static Debug = DebugAPI;
  static DocumentIngest = DocumentIngestAPI;
  static PolicyNotifications = PolicyNotificationsAPI;
  static PolicyWorksheets = PolicyWorksheetsAPI;
  static Embeds = EmbedsAPI;
  static EmbedPicker = EmbedPickerAPI;
  static Escalations = EscalationsAPI;
  static Events = EventsAPI;
  static FMS = FMSAPI;
  static GlobalSearch = GlobalSearchAPI;
  static Google = GoogleAPI;
  static Group = GroupAPI;
  static Journeys = JourneysAPI;
  static Leases = LeasesAPI;
  static Leads = LeadsAPI;
  static LegacyServer = LegacyServerAPI;
  static Locations = LocationsAPI;
  static LocationVars = LocationVarsAPI;
  static MemberInvite = MemberInviteAPI;
  static Members = MembersAPI;
  static Menu = MenuAPI;
  static Messages = MessagesAPI;
  static Messaging = MessagingAPI;
  static NLP = NLPAPI;
  static Notes = NotesAPI;
  static NotificationPreferences = NotificationPreferencesAPI;
  static Notifications = NotificationsAPI;
  static Org = OrgsAPI;
  static Payments = PaymentsAPI;
  static Push = PushAPI;
  static Quests = QuestsAPI;
  static Reviews = ReviewsAPI;
  static Roles = RolesAPI;
  static RoutingGroup = RoutingGroupAPI;
  static S3 = S3API;
  static TestCaller = TestCallerAPI;
  static Schedule = ScheduleAPI;
  static Scraper = ScraperAPI;
  static Onboarding = OnboardingAPI;
  static Sessions = SessionsAPI;
  static Sequences = SequencesAPI;
  static SequenceConfig = SequenceConfigAPI;
  static SequenceTestRuns = SequenceTestRunsAPI;
  static SMSGroups = SMSGroupsAPI;
  static Spot = SpotAPI;
  static Tables = TablesAPI;
  static Tenants = TenantsAPI;
  static Ticketing = TicketingAPI;
  static TicketingAccess = TicketingAccessAPI;
  static Time = TimeAPI;
  static TwilioSetup = TwilioSetupAPI;
  static Units = UnitsAPI;
  static UserStories = UserStoriesAPI;
  static PhoneVerification = PhoneVerificationAPI;
  static Users = UsersAPI;
  static UserVars = UserVarsAPI;
  static Vars = VarsAPI;
  static Voice = VoiceAPI;
  static URL = URLAPI;
  static Omni = OmniAPI;
  static Widgets = WidgetsAPI;
  static WidgetIdentity = WidgetIdentityAPI;
  static WidgetAccount = WidgetAccountAPI;
  static TenantPage = TenantPageAPI;
  static Ctas = CtasAPI;
  static OutboundAllowlist = OutboundAllowlistAPI;
  static SnowyCampaigns = SnowyCampaignsAPI;

  static StarterOpenings = StarterOpeningsAPI;
  static Reservations = ReservationsAPI;
}
